import { DallasTableDataCell } from '~/app/_ui/Dallas/Table/DallasTable';
import DallasStack from '~/app/_ui/Dallas/Stack/DallasStack';
import DallasSvgIconArrowRightAltOutlined from '../../../../../../../_ui/Dallas/Icons/DallasSvgIconArrowRightAltOutlined';

type Props = {
  className?: string;
};

export default function TripArrowWithExtraStopCountSkeletonCell({
  className,
}: Props) {
  return (
    <DallasTableDataCell className={className}>
      <DallasStack alignVertical="center" alignHorizontal="center">
        <DallasSvgIconArrowRightAltOutlined color="darkGray" />
      </DallasStack>
    </DallasTableDataCell>
  );
}
